import { render, staticRenderFns } from "./PFSignup.vue?vue&type=template&id=c34f50a4"
import script from "./PFSignup.vue?vue&type=script&lang=js"
export * from "./PFSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports